import React, { Fragment } from 'react';
import { Row, Col } from 'reactstrap';
import { Menu } from 'react-feather';
import { Link } from 'react-router-dom';
import RightHeader from './RightHeader/index';

const Header = ({ onHamburgerClick }) => {
  return (
    <Fragment>
      <div className="page-header">
        <Row className="header-wrapper m-0 align-items-center" style={{ height: '64px' }}>
          <Col className="col-auto d-flex align-items-center gap-1 ps-3">
            <button
              className="hamburger-btn"
              onClick={onHamburgerClick}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color: '#9CA3AF', padding: '4px', display: 'flex', alignItems: 'center'
              }}
            >
              <Menu size={22} />
            </button>
            <Link to="/dashboard" style={{ textDecoration: 'none' }}>
              <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Manzili Smart" style={{ height: 70, maxWidth: '100%' }} />
            </Link>
          </Col>
          <Col className="col-auto ms-auto pe-3">
            <RightHeader />
          </Col>
        </Row>
      </div>
    </Fragment>
  );
};

export default Header;
